export default __webpack_public_path__ + "static/media/HBSemesterNotebook-icon.1df02c4a.png";